import { ExcelValidationConfig } from '@extendedWarranty/types/extendedWarranty';

enum EXCEL_EXPECTED_HEADERS {
    INSTALLATION_NAME = 'A',
    INSTALLATION_DATE = 'B',
    SERIAL_NUMBER = 'C',
    WILL_PROVIDE_SUPPORT = 'D',
}

enum EXCEL_COL_ORDER {
    INSTALLATION_NAME = 0,
    INSTALLATION_DATE = 1,
    SERIAL_NUMBER = 2,
    WILL_PROVIDE_SUPPORT = 3,
}

const EXCEL_HEADERS: Record<EXCEL_COL_ORDER, EXCEL_EXPECTED_HEADERS> = {
    [EXCEL_COL_ORDER.INSTALLATION_NAME]: EXCEL_EXPECTED_HEADERS.INSTALLATION_NAME,
    [EXCEL_COL_ORDER.INSTALLATION_DATE]: EXCEL_EXPECTED_HEADERS.INSTALLATION_DATE,
    [EXCEL_COL_ORDER.SERIAL_NUMBER]: EXCEL_EXPECTED_HEADERS.SERIAL_NUMBER,
    [EXCEL_COL_ORDER.WILL_PROVIDE_SUPPORT]: EXCEL_EXPECTED_HEADERS.WILL_PROVIDE_SUPPORT,
};

const EXCEL_VALIDATION_CONFIG: ExcelValidationConfig = {
    sheetIndex: 0,
    startingRow: 17,
    startingCol: EXCEL_EXPECTED_HEADERS.INSTALLATION_NAME,
    expectedHeaders: {
        [EXCEL_EXPECTED_HEADERS.INSTALLATION_NAME]: ['installation', 'name'],
        [EXCEL_EXPECTED_HEADERS.INSTALLATION_DATE]: ['date', 'yyyy-mm-dd'],
        [EXCEL_EXPECTED_HEADERS.SERIAL_NUMBER]: ['s/n'],
        [EXCEL_EXPECTED_HEADERS.WILL_PROVIDE_SUPPORT]: ['provide', 'support'],
    },
};

const PDF_EXPORT_PAGE_CHUNK_SIZE = 23;

const SERIAL_NUMBER_REGEX = /^HQ[A-Z0-9]{9}$/;

export {
    EXCEL_COL_ORDER,
    EXCEL_EXPECTED_HEADERS,
    EXCEL_HEADERS,
    EXCEL_VALIDATION_CONFIG,
    PDF_EXPORT_PAGE_CHUNK_SIZE,
    SERIAL_NUMBER_REGEX,
};
